// Documentation module translations - Spanish (Español)
export const documentationES = {
  // Common
  'Documentation': 'Documentación',
  'Need Help?': '¿Necesitas Ayuda?',
  'Email': 'Correo electrónico',
  'Documentation Center': 'Centro de Documentación',
  'Check other guides in the Documentation Center': 'Consulta otras guías en el Centro de Documentación',
  'If you have questions about payment modes or booking management, our support team is here to help:':
    'Si tienes preguntas sobre modos de pago o gestión de reservas, nuestro equipo de soporte está aquí para ayudarte:',

  // Categories
  'Studio Bookings': 'Reservas de Estudio',
  'Event Setup': 'Configuración de Eventos',
  'Tickets & Pricing': 'Entradas y Precios',

  // Payment Mode Documentation
  'Payment Mode Management Guide': 'Guía de Gestión de Modos de Pago',
  'This comprehensive guide explains how to configure payment modes for your studio bookings and manage the booking approval workflow. Payment modes control how customers pay for their bookings and when money is collected.':
    'Esta guía completa explica cómo configurar los modos de pago para las reservas de tu estudio y gestionar el flujo de aprobación de reservas. Los modos de pago controlan cómo los clientes pagan por sus reservas y cuándo se cobra el dinero.',

  // Overview Section
  'Overview: Understanding Payment Modes': 'Descripción General: Entendiendo los Modos de Pago',
  'The system supports four different payment modes, each designed for different business needs:':
    'El sistema admite cuatro modos de pago diferentes, cada uno diseñado para diferentes necesidades comerciales:',

  // Payment Modes
  'Manual Mode': 'Modo Manual',
  'Full Payment Mode': 'Modo de Pago Completo',
  'Deposit Mode': 'Modo de Depósito',
  'Hold Mode': 'Modo de Retención',

  // Payment Mode Labels
  'No online payment': 'Sin pago en línea',
  'Instant charge': 'Cargo instantáneo',
  'Partial charge': 'Cargo parcial',
  'Authorization hold': 'Retención de autorización',

  // Payment Mode Descriptions
  'Customer submits booking request without paying online. Owner approves, then collects payment later (cash, invoice, etc.)':
    'El cliente envía la solicitud de reserva sin pagar en línea. El propietario aprueba y luego cobra el pago más tarde (efectivo, factura, etc.)',
  'Customer pays 100% upfront via online payment. Booking is automatically confirmed once payment succeeds.':
    'El cliente paga el 100% por adelantado mediante pago en línea. La reserva se confirma automáticamente una vez que el pago es exitoso.',
  'Customer pays a deposit upfront (e.g., 30%). Remaining balance collected later (before/after session).':
    'El cliente paga un depósito por adelantado (por ejemplo, 30%). El saldo restante se cobra más tarde (antes/después de la sesión).',
  'Card is authorized but NOT charged. Owner approves booking → money is captured. Owner rejects → hold is released.':
    'La tarjeta se autoriza pero NO se cobra. El propietario aprueba la reserva → se captura el dinero. El propietario rechaza → se libera la retención.',

  // Configuration Section
  'How to Configure Payment Settings': 'Cómo Configurar los Ajustes de Pago',
  'Payment settings are configured per studio in the Manage Settings page under the Pricing & Payment tab. Navigate to: Studios → [Your Studio] → Manage Settings → Pricing & Payment':
    'Los ajustes de pago se configuran por estudio en la página Administrar Configuración bajo la pestaña Precios y Pagos. Navega a: Estudios → [Tu Estudio] → Administrar Configuración → Precios y Pagos',

  // Configuration Steps
  'Access Payment Settings': 'Acceder a Configuración de Pagos',
  'Select Payment Mode': 'Seleccionar Modo de Pago',
  'Configure Deposit Settings (if using Deposit Mode)': 'Configurar Ajustes de Depósito (si usas Modo de Depósito)',
  'Configure Booking Rules': 'Configurar Reglas de Reserva',
  'Save Your Changes': 'Guardar tus Cambios',

  // Booking Management
  'Managing Booking Requests': 'Gestión de Solicitudes de Reserva',
  'Understanding Booking Statuses': 'Entendiendo los Estados de Reserva',
  'Understanding Payment Statuses': 'Entendiendo los Estados de Pago',

  // Workflow
  'Workflow: Approving Bookings (Manual & Hold Modes)': 'Flujo de Trabajo: Aprobación de Reservas (Modos Manual y Retención)',
  'View Pending Approvals': 'Ver Aprobaciones Pendientes',
  'Review Booking Details': 'Revisar Detalles de Reserva',
  'Approve the Booking': 'Aprobar la Reserva',
  'Reject the Booking (if needed)': 'Rechazar la Reserva (si es necesario)',

  // Best Practices
  'Best Practices & Tips': 'Mejores Prácticas y Consejos',
  'Choose the Right Mode for Your Business': 'Elige el Modo Adecuado para tu Negocio',
  'Respond to Booking Requests Quickly': 'Responde a las Solicitudes de Reserva Rápidamente',
  'Provide Clear Rejection Reasons': 'Proporciona Razones de Rechazo Claras',
  'Set Appropriate Deposit Amounts': 'Establece Montos de Depósito Apropiados',
  'Monitor Your Booking Dashboard': 'Monitorea tu Panel de Reservas',
  'Track Your Revenue': 'Rastrea tus Ingresos',

  // Quick Reference
  'Quick Reference: Payment Mode Comparison': 'Referencia Rápida: Comparación de Modos de Pago',

  // Table Headers and Common Terms
  'Status': 'Estado',
  'What It Means': 'Qué Significa',
  'Payment Status': 'Estado de Pago',
  'Actions Available': 'Acciones Disponibles',
  'Feature': 'Característica',
  'Manual': 'Manual',
  'Full Payment': 'Pago Completo',
  'Deposit': 'Depósito',
  'Hold': 'Retención',
  'Best For': 'Mejor Para',
  'Mode': 'Modo',

  // Payment Statuses
  'Unpaid': 'No Pagado',
  'Pending': 'Pendiente',
  'On Hold': 'En Retención',
  'Deposit Paid': 'Depósito Pagado',
  'Paid': 'Pagado',
  'Refunded': 'Reembolsado',

  // Booking Statuses
  'Pending Approval': 'Pendiente de Aprobación',
  'Confirmed': 'Confirmado',
  'In Progress': 'En Progreso',
  'Completed': 'Completado',
  'Rejected': 'Rechazado',
  'Cancelled': 'Cancelado',
  'No Show': 'No se Presentó',

  // Actions
  'Approve': 'Aprobar',
  'Reject': 'Rechazar',
  'View': 'Ver',
  'Cancel': 'Cancelar',
  'Mark In Progress': 'Marcar En Progreso',
  'Mark Completed': 'Marcar Completado',
  'Collect Balance': 'Cobrar Saldo',

  // Common Descriptions
  'No payment received yet. Common in manual mode bookings before collection.':
    'Aún no se ha recibido el pago. Común en reservas de modo manual antes del cobro.',
  'Payment initiated but not completed. Customer in checkout process.':
    'Pago iniciado pero no completado. Cliente en proceso de pago.',
  'Full payment received and confirmed. No balance owed.':
    'Pago completo recibido y confirmado. Sin saldo pendiente.',
  'Payment was refunded back to customer (full or partial refund).':
    'El pago fue reembolsado al cliente (reembolso total o parcial).',
};
